import { ExternalLink } from 'lucide-react';
import React from 'react';
import { PageHeader } from '../../components/common/PageHeader';
import { AcquireMetrics } from '../metrics/tabs/AcquireMetrics';

export const AcquirePage: React.FC = () => {
  return (
    <section className="space-y-6">
      <PageHeader
        title="Acquire"
        description="AI-powered ad campaign creation and management for Google and Meta"
        right={
          <a
            href="https://docs.embedreach.com/acquire/introduction"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 transition-colors">
            API Docs
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
        }
      />
      <AcquireMetrics />
    </section>
  );
};
